(() => {
  class ScanwellShippingFormController {
    constructor($rootScope, $scope, $timeout, $interval, toastr, $state, ngDialog, Utils, Orders, Notifications) {
      'ngInject';

      Object.assign(this, {
        $scope,
        $rootScope,
        $timeout,
        $interval,
        toastr,
        $state,
        ngDialog,
        Utils,
        Orders,
        Notifications,
        labInfo: $scope.ngDialogData.labInfo,
        oldLabInfo: angular.copy($scope.ngDialogData.labInfo)
      });
      $scope.$on('ngDialog.opened', function (e, $dialog) {
        $(".ngdialog-theme-default.scanwell-shipping-form-modal").children(".ngdialog-content").draggable({
          handle: ".scanwell-handler"
        });
      });
      this.scanwellShippingStatuses = [{
        type: "in-progress",
        name: 'In Progress'
      }, {
        type: 'hold',
        name: 'On Hold'
      }, {
        type: 'ordered',
        name: 'Ordered'
      }, {
        type: 'shipped',
        name: 'Shipped'
      }];
      this.getDetails();
    }

    close() {
      this.$scope.closeThisDialog(null);
    }

    getDetails() {
      this.Orders.getScanwellShippingDetails(this.labInfo.order_id, this.labInfo.id).then(({
        data
      }) => {
        this.labInfo.shipment = data;
        this.oldLabInfo.shipment = angular.copy(data);
      }).catch(err => {
        // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
        if (err && err.data && err.data.error_message) {
          this.toastr.error(err.data.error_message);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      });
    }

    formHasChanged() {
      if (this.oldLabInfo.shipment.status != this.labInfo.shipment.status || this.oldLabInfo.shipment.tracking_url != this.labInfo.shipment.tracking_url || this.oldLabInfo.shipment.notes != this.labInfo.shipment.notes || this.oldLabInfo.shipment.test_id != this.labInfo.shipment.test_id) {
        return true;
      }

      return false;
    }

    update() {
      if (!this.labInfo.shipment.status) {
        this.toastr.warning("Please select one status.");
        return;
      }

      const payload = {}; // Now we always send the "status" in the payload

      payload.status = this.labInfo.shipment.status; // For status "shipped" we always send "tracking_url" in the payload even if it's empty (API validates)

      if (this.labInfo.shipment.status == 'shipped' || this.oldLabInfo.shipment.tracking_url != this.labInfo.shipment.tracking_url) {
        payload.tracking_url = this.labInfo.shipment.tracking_url ? this.labInfo.shipment.tracking_url : "";
      }

      if (this.oldLabInfo.shipment.notes != this.labInfo.shipment.notes) {
        payload.notes = this.labInfo.shipment.notes ? this.labInfo.shipment.notes : "";
      }

      if (this.oldLabInfo.shipment.test_id != this.labInfo.shipment.test_id) {
        payload.test_kit_id = this.labInfo.shipment.test_id ? this.labInfo.shipment.test_id : null;
      }

      this.Orders.updateScanwellShippingDetails(this.labInfo.order_id, this.labInfo.id, payload).then(() => {
        this.toastr.success("Details were updated successfully.");
        var response = {
          success: true
        };
        this.$scope.closeThisDialog(response);
      }).catch(err => {
        // THIS IS THE WAY TO DISPLAY ERRORS FOR GO ENDPOINTS
        if (err && err.data && err.data.error_message) {
          this.toastr.error(err.data.error_message);
        } else {
          this.toastr.error(this.Notifications.generic.failure);
        }
      });
    }

  }

  ScanwellShippingFormController.$inject = ["$rootScope", "$scope", "$timeout", "$interval", "toastr", "$state", "ngDialog", "Utils", "Orders", "Notifications"];
  angular.module('pims').controller('ScanwellShippingFormController', ScanwellShippingFormController);
})();